import { i18next } from '@frontend/i18n';
import { CallIntelDashboardWidgetType, ComparisonPeriodType } from './types';

export const CI_UNHAPPY_WIDGET_FF = 'call-intel:dashboard-widgets:unhappy-calls';
export const CI_SCHEDULE_OPP_WIDGET_FF = 'call-intel:dashboard-widgets:schedule-opportunities';
export const CI_UNSCHEDULED_OPP_WIDGET_FF = 'call-intel:dashboard-widgets:unscheduled';
export const CI_DEMO_WIDGET_FF = 'call-intel:dashboard-widgets:enable-demo';

export const API_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS';
export const DISPLAY_DATE_FORMAT = 'MMM D, YYYY h:mm A';

export const ComparisonPeriodLabel: Record<ComparisonPeriodType, string> = {
  week: i18next.t('Week', { ns: 'callIntelDashboardWidgets' }),
  month: i18next.t('Month', { ns: 'callIntelDashboardWidgets' }),
};

export const CallIntelWidgetFFMap: Record<CallIntelDashboardWidgetType, string> = {
  'call-intel-unhappy-calls-widget': CI_UNHAPPY_WIDGET_FF,
  'call-intel-scheduling-opportunities-widget': CI_SCHEDULE_OPP_WIDGET_FF,
  'call-intel-unscheduled-widget': CI_UNSCHEDULED_OPP_WIDGET_FF,
};
